import { Heading, Para, Stack } from '@drycut/ui-components';

import CutNowButton from '../CutNowButton';

export default function CouponNotFound(): React.ReactElement {
  return (
    <Stack gap={6} className="items-center text-center text-pretty">
      <Heading variant="h2">Gutschein existiert nicht</Heading>

      <Stack gap={2}>
        <Para>Dieser Gutscheincode existiert leider nicht.</Para>

        <Para>
          Du kannst aber auf unserer Website jederzeit die aktuelle Wartezeit sehen und Deinen
          nächsten DRYCUT unkompliziert buchen.
        </Para>
      </Stack>

      <CutNowButton />
    </Stack>
  );
}
